module.exports = __webpack_public_path__ + "static/img/obtain-bg.2f9796b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/city-agent/obtain-bg.jpg
// module id = 453f
// module chunks = 4